// extracted by mini-css-extract-plugin
export default {"products":"nB-z","card":"oB-z","oosMessaging":"pB-z"};